import { TextField, InputAdornment } from "@mui/material";
import { WidgetProps } from "@rjsf/utils";
import { inputStyles, renderLabel, renderDescriptionTooltip } from "./common";

// Number Input Widget with maxLength and validation
export const NumberWidget = (props: WidgetProps) => {
  const { id, value, label, onChange, required, disabled, readonly, options, schema } = props;
  const maxLength = options?.maxLength as number | undefined;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const val = event.target.value;
    if (val === "") {
      onChange(undefined);
      return;
    }
    if (maxLength && val.replace(/[^0-9.-]/g, "").length > maxLength) {
      return;
    }
    if (schema.type?.includes("integer")) {
      // if schema accepts integers, parse value as integer
      const numVal = parseInt(val, 10);
      if (!isNaN(numVal)) {
        onChange(numVal);
      }
    } else {
      // if schema accepts srtings, pass value as string
      onChange(val);
    }
  };

  return (
    <TextField
      id={id}
      fullWidth
      type="number"
      value={value ?? ""}
      onChange={handleChange}
      disabled={disabled}
      slotProps={{
        input: {
          readOnly: readonly,
          endAdornment: schema.description ? (
            <InputAdornment position="end">
              {renderDescriptionTooltip(schema.description)}
            </InputAdornment>
          ) : null,
        },
        htmlInput: {
          min: schema?.minimum,
          max: schema?.maximum,
          step: schema?.multipleOf || "any",
        },
      }}
      label={renderLabel(label, !!required)}
      required={required}
      size="small"
      variant="outlined"
      sx={inputStyles}
    />
  );
};
